import { useState } from "preact/hooks";

type MessageInputProps = {
  disabled: boolean;
  onSend: (message: string) => void;
};

export default function MessageInput({ disabled, onSend }: MessageInputProps) {
  const [value, setValue] = useState("");

  function handleSubmit(event: Event) {
    event.preventDefault();
    const message = value.trim();

    if (!message || disabled) {
      return;
    }

    setValue("");
    onSend(message);
  }

  return (
    <form className="qk-chatbot-input" onSubmit={handleSubmit}>
      <input
        type="text"
        value={value}
        maxLength={1000}
        disabled={disabled}
        placeholder="Ecrivez votre message"
        aria-label="Message"
        onInput={(event) => setValue((event.currentTarget as HTMLInputElement).value)}
      />
      <button type="submit" disabled={disabled || !value.trim()} aria-label="Envoyer">
        <svg aria-hidden="true" viewBox="0 0 24 24" width="18" height="18">
          <path d="M5 12h13M13 6l6 6-6 6" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
      </button>
    </form>
  );
}
